<div class="content-wrap">
  <div class="profile-component-wrapper">
    <div class="component-header">
      <div class="component-header-right">
        <button
          class="hadsup-btn hadsup-primary-dark"
          (click)="updateProfile()"
          [disabled]="!profileForm.valid && profileForm.status !== 'VALID' ||  !profileForm.dirty"
        >
          <div class="button-loading" *ngIf="loadingData">
            <span class="button-text">Loading...</span>
          </div>
          <span *ngIf="!loadingData">Save</span>
        </button>
        <button
          class="hadsup-btn hadsup-btn-default"
          (click)="discardChanges()"
        >
          Cancel
        </button>
      </div>
    </div>
    <div class="profile-body">
      <div class="profile-info-wrapper">
        <div class="profile-info-row">
          <div class="info-col">
            <h5>Contact person</h5>
            <form class="add-form-wrapper" [formGroup]="profileForm">
              <div class="form-row">
                <div class="form-group">
                  <div class="hadsup-input-wrap profile-wrap">
                    <div class="profile-pic rounded-circle">
                      <img
                        *ngIf="!imagePreview && companyLogo"
                        [src]="companyLogo"
                        alt="Selected Image"
                      />
                      <img
                        *ngIf="imagePreview"
                        [src]="imagePreview"
                        alt="Selected Image"
                      />
                    </div>

                    <div
                      class="upload-wrap input"
                      (drop)="onFileUpload($event)"
                      (dragover)="onDragOver($event)"
                    >
                      <div class="camera-icon" (click)="fileInput.click()">
                        <i class="uil uil-upload"></i>
                      </div>
                      <div class="upload-text" (click)="fileInput.click()">
                        <span class="upload-text-inner"> Click to upload </span
                        >or drag and drop
                        <br />
                        <small>SVG, PNG, JPG, or GIF (max. 800x400px)</small>
                      </div>
                    </div>

                    <input
                      #fileInput
                      id="file-input"
                      type="file"
                      (change)="onFileUpload($event)"
                      hidden
                      accept="image/*"
                    />
                    <input type="hidden" formControlName="profile_photo" />
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>E-mail<span class="required-asterisk">*</span></label>
                  <input
                    type="text"
                    placeholder="E-mail"
                    [value]="profileForm.get('email')?.value" disabled
                    readonly="true"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label
                    >Contact person first name<span class="required-asterisk"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    placeholder="Contact person first name"
                    formControlName="user_name"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>Contact person last name</label>
                  <input
                    type="text"
                    placeholder="Contact person last name"
                    formControlName="user_surname"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>Phone number</label>
                  <div class="mobile_wrapper">
                    <hadsup-custom-select
                      defaultText="Prefix" [enableSearch]="true"
                      labelName=""
                      [items]="phonePrefixList"
                      [nameProp]="'description'"
                      [valueProp]="'calling_code'"
                      [value]="selectedPhonePrefix"
                      (selectionChange)="PrefixSelection($event)"
                      [displayValueProp]="true"
                    ></hadsup-custom-select>
                    <input
                      class="input"
                      #input
                      placeholder="Enter your phone number"
                      formControlName="phone"
                      [textMask]="phoneMask"
                      (keypress)="isNumber($event)"
                      maxlength="10"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="info-col">
            <h5>Address</h5>
            <form class="add-form-wrapper" [formGroup]="profileForm">
              <div class="form-row">
                <div class="form-group">
                  <label>Address</label>
                  <hadsup-g-autocomplete
                    [form]="profileForm"
                    [placeholder]="'Enter address'"
                    (onChangePlace)="setGeoposition($event)"
                    [formControlName]="'address'"
                  >
                  </hadsup-g-autocomplete>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>Street and number</label>
                  <input
                    class="input"
                    type="text"
                    placeholder="Street"
                    formControlName="street"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Town</label>
                  <input
                    class="input"
                    type="text"
                    placeholder="Town"
                    formControlName="town"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Postcode</label>
                  <input
                    type="text"
                    placeholder="Postcode"
                    formControlName="postcode"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>Country</label>
                  <input
                    type="text"
                    autoComplete="none"
                    placeholder="Country"
                    formControlName="address_country"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="profile-component-wrapper">
    <div class="profile-body password-update-form">
      <div class="profile-info-wrapper">
        <div class="profile-info-row">
          <div class="info-col">
            <h5>Change password</h5>
            <div class="form-card">
              <form [formGroup]="changePasswordForm" class="changePasswordForm">
                <div class="form-group">
                  <label>Old password </label>
                  <div class="wrapper">
                    <input
                      class="input"
                      placeholder="Enter old password"
                      formControlName="old_password"
                      type="{{ oldPasswordType }}"
                    />
                    <span class="eye-icon"
                      ><i
                        class="uil {{
                          isOldPassword ? 'uil-eye-slash' : 'uil-eye'
                        }} s-21"
                        (click)="passwordHideShow('OLD')"
                      ></i
                    ></span>
                  </div>
                  <div class="error-message">
                    <div
                      *ngIf="submittedPassword && f['old_password'].errors"
                      class="error"
                    >
                      <div *ngIf="f['old_password'].errors">
                        The password field is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>New password</label>
                  <div class="wrapper">
                    <input
                      class="input"
                      placeholder="Enter new password"
                      formControlName="password"
                      type="{{ newPasswordType }}"
                    />
                    <span class="eye-icon"
                      ><i
                        class="uil {{
                          isNewPassword ? 'uil-eye-slash' : 'uil-eye'
                        }} s-21"
                        (click)="passwordHideShow('NEW')"
                      ></i
                    ></span>
                  </div>
                  <div class="error-message">
                    <div
                      class="error"
                      *ngIf="submittedPassword && f['password'].errors"
                    >
                      <div *ngIf="f['password'].errors['required']">
                        The new password field is required
                      </div>
                      <div *ngIf="f['password'].errors['minlength']">
                        Password must be at least 8 characters
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Confirm new password</label>
                  <div class="wrapper">
                    <input
                      class="input"
                      type="{{ confirmPasswordType }}"
                      placeholder="Confirm new password"
                      formControlName="confirm_password"
                    />
                    <span class="eye-icon"
                      ><i
                        class="uil {{
                          isConfirmPassword ? 'uil-eye-slash' : 'uil-eye'
                        }} s-21"
                        (click)="passwordHideShow('CONFIRM')"
                      ></i
                    ></span>
                  </div>
                  <div class="error-message">
                    <div *ngIf="submittedPassword && f['confirm_password'].errors">
                      <div
                        class="error"
                        *ngIf="
                          f['confirm_password'].errors &&
                          f['confirm_password'].errors['required']
                        "
                      >
                        The confirm Password field is required
                      </div>
                      <div
                        class="error"
                        *ngIf="f['confirm_password'].errors['mustMatch']"
                      >
                        Passwords must match
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-actions">
                  <button class="action-btn" (click)="updatePassword()">
                    <span *ngIf="!isLoading"> Change password</span>
                    <div class="button-loading" *ngIf="isLoading">
                      <span class="button-text">Loading...</span>
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
